import { PostModel } from '../../../shared/models/post.model';
import { SearchPostResult } from '../../../shared/models/responses/search/findGeneric.response';

/**
 * Builds a {@link PostModel} from generic search post hits.
 * Several fields are absent from {@link SearchPostResult}.
 */
export function mapSearchPostResultToPostModel(result: SearchPostResult): PostModel {
  const id = Number.parseInt(String(result.id), 10);
  const {
    timestamp,
    publishAt,
    expireAt,
    editedAt,
    isImportant,
    isPublished,
    isExpired,
    isBookmarked,
    pendingMedia,
    commentCount,
    relatedProfiles,
    sharedWithGroups,
    attachments,
    content,
    title,
    allowComments,
  } = result;
  return {
    id,
    title,
    sharedWithGroups,
    timestamp,
    publishAt,
    expireAt,
    editedAt,
    isImportant,
    isExpired,
    isBookmarked,
    isPublished,
    pendingMedia,
    commentCount,
    relatedProfiles,
    attachments,
    allowComments,
    content: { html: content ?? '' },
    ownerProfile: result.creator,
    canCurrentUserDelete: false,
    canCurrentUserReport: false,
    canCurrentUserComment: false,
  };
}
